import React from 'react';
import { FieldTooltip } from './FieldTooltip';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
  tooltip?: string;
}

export const Input: React.FC<InputProps> = ({
  label,
  error,
  icon,
  tooltip,
  className = '',
  id,
  ...props
}) => {
  return (
    <div>
      {label && (
        <div className="mb-1 flex items-center">
          <label htmlFor={id} className="block text-[13px] font-medium text-text-grey">
            {label}
          </label>
          {tooltip && <FieldTooltip text={tooltip} />}
        </div>
      )}
      <div className="relative">
        {icon && (
          <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
            {icon}
          </div>
        )}
        <input
          id={id}
          className={`
            ${icon ? 'pl-10' : 'pl-3'}
            appearance-none block w-full px-3 py-2.5 rounded-lg text-[13px] text-text-grey
            placeholder:text-heritage-grey focus:outline-none transition-colors
            ${error ? 'border border-readable-red focus:border-readable-red' : 'border border-[#E2E5EA] focus:border-blueprint-blue'}
            ${className}
          `}
          {...props}
        />
      </div>
      {error && (
        <p className="mt-2 text-[12px] text-readable-red">{error}</p>
      )}
    </div>
  );
}; 